// extracted by css-extract-rspack-plugin
export default {"cropImage":"crop-image_ZuZpi"};